import { memo, useCallback, useContext } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { AuthContext, useAuth } from '~auth/AuthContext'
import { useSetPassword } from '~auth/hooks/user'

import { SetPasswordForm } from './components'
import { SetPasswordFormValue } from './components/SetPasswordFormValue'

import * as SC from './styles'

export const SetPassword = memo(() => {
  const { portalName } = useContext(AuthContext)
  const setPasswordMutation = useSetPassword(portalName)
  const key = getRouteApi('/_auth/auth/password-reset').useSearch({ select: (s) => s?.key })
  const { logoElement, footer } = useAuth()

  const setPassword = useCallback(
    (value: SetPasswordFormValue) =>
      setPasswordMutation.mutateAsync({
        password: value.password,
        key: key || ''
      }),
    [setPasswordMutation, key]
  )

  return (
    <SC.Box>
      <SetPasswordForm onSubmit={setPassword} logoElement={logoElement} footer={footer} />
    </SC.Box>
  )
})
